import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import store from "@/store";
  import { UserRoles } from "@/enums/UserRoles";
  import { Lawyer } from "@/types/UserInterface";
  import Dropdown from "@/components/ui/dropdown/DropDown.vue";

  interface Props {
    estateName: string;
    isOpen: boolean;
  }
  interface Emits {
    (event: "lawyerId", lawyerId: string): void;
    (event: "close"): void;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AddLawyerToEstateModal',
  props: {
    estateName: {},
    isOpen: { type: Boolean }
  },
  emits: ["lawyerId", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const lawyers = ref([] as Lawyer[]);
  const activeLawyer = ref({} as Lawyer);

  const onLawyer = (lawyer: Lawyer) => {
    activeLawyer.value = lawyer;
  };
  const onAssign = () => {
    emits("lawyerId", activeLawyer.value._id);
    activeLawyer.value = {} as Lawyer;
  };
  const onClose = () => {
    emits("close");
    activeLawyer.value = {} as Lawyer;
  };

  const fetchLawyers = () => {
    store
      .dispatch("user/getUsers", {
        role: UserRoles.LAWYER,
      })
      .then((response) => {
        lawyers.value = response.data.filter(
          (lawyer) => lawyer?.detailsId?.isExist
        );
      });
  };

  // initialization
  fetchLawyers();

const __returned__ = { emits, props, lawyers, activeLawyer, onLawyer, onAssign, onClose, fetchLawyers, ref, Modal, get store() { return store }, get UserRoles() { return UserRoles }, get Lawyer() { return Lawyer }, Dropdown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})